module.exports = __webpack_public_path__ + "img/nuki-smart-watch-en.a1a941fd.png";